import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { localizeDate } from '../../../utils/vuex';
import ApiService from '../../../services/apiService';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [true],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreCsvExportListScheduled',
  props: {
    search: {
      type: String,
      default: '',
      required: false
    },
    accounts: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    }
  },
  data: function data() {
    return {
      tableOptions: _objectSpread({}, defaultTableOptions),
      deletePrompt: false,
      runPrompt: false,
      scheduledJobs: [],
      serverItemsLength: -1,
      searchItem: ''
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'language'])), mapGetters({
    getAccountById: 'app/getAccountById'
  })), {}, {
    tableHeaders: function tableHeaders() {
      return [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.active'),
        value: 'active',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.id'),
        value: 'id',
        sortable: true
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.title'),
        value: 'title',
        sortable: true
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.account'),
        value: 'tenantId',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.tableHeaders.nextTrigger'),
        value: 'nextExecution',
        sortable: false
      }, {
        align: 'end',
        sortable: false,
        value: 'actions'
      }];
    },
    tableFooter: function tableFooter() {
      return {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      };
    }
  }),
  watch: {
    accounts: function accounts() {
      this.fetchJobs();
    },
    tableOptions: {
      handler: function handler(oldVal, newVal) {
        if (oldVal.itemsPerPage !== newVal.itemsPerPage) {
          this.tableOptions.page = 1;
        }

        this.fetchJobs();
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.fetchJobs();
  },
  methods: {
    localizeDate: localizeDate,
    fetchJobs: function fetchJobs() {
      var _this = this;

      var accountIds = this.accounts.map(function (account) {
        return account.id;
      });
      var _this$tableOptions = this.tableOptions,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc;
      var usedPage = page ? page - 1 : 0;
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      ApiService.fetchJobDefinitions(accountIds, usedPage * usedItemsPerPage, usedItemsPerPage, sortBy[0], sortDesc[0]).then(function (res) {
        _this.scheduledJobs = res.JobDefinition;
        _this.serverItemsLength = res.totalCount;
      }).catch(function () {
        _this.$snack(_this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.fetchError'), 'error');
      });
    },
    isIntegrationConfigBroken: function isIntegrationConfigBroken(item) {
      var emailConfig = item.parameters.emailsData;
      var isEmailBroken = !isEmpty(emailConfig) && !(emailConfig.html && emailConfig.subject && emailConfig.emails && emailConfig.emails.length && emailConfig.bridgeId);
      var thirdPartyConfig = item.parameters.thirdPartyData;
      var isThirdPartyBroken = !isEmpty(thirdPartyConfig) && !(thirdPartyConfig.payload && thirdPartyConfig.bridgeId);
      return isEmailBroken || isThirdPartyBroken;
    },
    tenantIdToName: function tenantIdToName(tenantId) {
      var account = this.getAccountById(tenantId);

      if (!account) {
        return tenantId;
      }

      return account.name;
    },
    handleActiveChange: function handleActiveChange(item, value) {
      var _this2 = this;

      ApiService.updateJobDefinition(item.id, value).then(function () {
        _this2.$snack(_this2.$i18n_t('BackgroundJobs.ScheduledExports.snacks.updateSuccess'), 'success');

        item.active = value;
      }).catch(function () {
        _this2.$nextTick(function () {
          _this2.$snack(_this2.$i18n_t('BackgroundJobs.ScheduledExports.snacks.updateError'), 'error');

          item.active = !value;
        });
      });
    },
    showDeletePrompt: function showDeletePrompt(itemId) {
      var _this3 = this;

      ApiService.deleteJobDefinition(itemId).then(function () {
        _this3.$snack(_this3.$i18n_t('BackgroundJobs.ScheduledExports.snacks.deleteSuccess'), 'success');

        _this3.fetchJobs();

        _this3.deletePrompt = false;
      }).catch(function () {
        _this3.$snack(_this3.$i18n_t('BackgroundJobs.ScheduledExports.snacks.deleteError'), 'error');

        _this3.deletePrompt = false;
      });
    },
    runJob: function runJob(itemId) {
      var _this4 = this;

      ApiService.runJobDefinition(itemId).then(function () {
        _this4.$snack(_this4.$i18n_t('BackgroundJobs.ScheduledExports.snacks.runSuccess'), 'success');
      }).catch(function () {
        _this4.$snack(_this4.$i18n_t('BackgroundJobs.ScheduledExports.snacks.runError'), 'error');
      }).finally(function () {
        _this4.runPrompt = false;
      });
    }
  }
};